export const PERSIST_PROCESS_STATEMENT_QUESTIONS_REQUEST = 'PERSIST_PROCESS_STATEMENT_QUESTIONS_REQUEST';

export const persistProcessStatementQuestionsRequest = ( questions ) => ({
    type: PERSIST_PROCESS_STATEMENT_QUESTIONS_REQUEST,
    payload: {
        questions
    }
});
